import ReportDialog from "./ReportDialog";

export default function Masthead({ eyebrow, title, subtitle, meta, module }) {
  return (
    <div
      className="flex justify-between items-end flex-wrap gap-3 px-[26px] py-[18px] bg-white"
      style={{ borderBottom: "3px solid var(--cv-crimson)" }}
      data-testid="masthead"
    >
      <div>
        <div
          className="text-[14px] font-bold small-caps"
          style={{ color: "var(--cv-amber)" }}
        >
          {eyebrow}
        </div>
        <div
          className="text-[28px] font-bold small-caps leading-tight font-serif-display"
          style={{ color: "var(--cv-crimson)" }}
        >
          {title}
        </div>
        {subtitle && (
          <div className="text-[14px] mt-1" style={{ color: "var(--cv-charcoal-soft)" }}>
            {subtitle}
          </div>
        )}
      </div>
      <div className="flex flex-col items-end gap-2">
        {module && <ReportDialog module={module} />}
        {meta && (
          <div
            className="text-right text-[13.5px]"
            style={{ color: "var(--cv-charcoal-soft)" }}
          >
            {meta}
          </div>
        )}
      </div>
    </div>
  );
}
